import React, { useEffect, useState } from "react";
import logo from "../../assets/imgs/jhonks-mark.png";

const LogoLoader = ({
  fullScreen = false,
  label = "Loading",
  slowAfterMs = 8000,
}) => {
  const [offline, setOffline] = useState(
    typeof navigator !== "undefined" ? navigator.onLine === false : false
  );
  const [slow, setSlow] = useState(false);

  useEffect(() => {
    const timer = window.setTimeout(() => setSlow(true), slowAfterMs);
    const handleOffline = () => setOffline(true);
    const handleOnline = () => setOffline(false);
    window.addEventListener("offline", handleOffline);
    window.addEventListener("online", handleOnline);
    return () => {
      window.clearTimeout(timer);
      window.removeEventListener("offline", handleOffline);
      window.removeEventListener("online", handleOnline);
    };
  }, [slowAfterMs]);

  const waitingOnNetwork = offline || slow;
  const title = offline ? "No internet connection" : label;
  const detail = offline
    ? "Jhonks cannot reach the server right now. Check your connection. The page will continue as soon as you are back online."
    : "This is taking longer than usual. Your connection may be slow or unstable. Jhonks is still trying.";

  return (
    <div
      className={
        fullScreen
          ? "min-h-screen flex flex-col items-center justify-center px-6"
          : "flex flex-col items-center justify-center px-6 py-4"
      }
      role="status"
      aria-live="polite"
    >
      <div className="jhonks-loader-stage" aria-hidden="true">
        <span className="jhonks-loader-ring" />
        <span className="jhonks-loader-ring jhonks-loader-ring-delay" />
        <img src={logo} alt="" className="jhonks-loader-logo" />
      </div>
      <p className="mt-4 text-sm font-medium text-gray-700">{title}</p>
      {waitingOnNetwork && (
        <p className="mt-2 max-w-sm text-center text-sm leading-relaxed text-gray-500">
          {detail}
        </p>
      )}
    </div>
  );
};

export default LogoLoader;
